import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMapPin, FiClock, FiPhone, FiMail } = FiIcons;

function Footer() {
  return (
    <footer className="bg-[#333333] text-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://media.phst.co.za/file/ph/primehost-logo-730-dm-trns.png" 
              alt="Primehost" 
              className="h-8 w-auto mb-4"
            />
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              Elevate your business with digital solutions that combine striking design with rock-solid technical performance.
            </p>
            <div className="space-y-2 text-sm">
              <div className="flex items-center space-x-2 text-gray-300">
                <SafeIcon icon={FiMapPin} className="h-4 w-4" />
                <span>Waterfall, Midrand, Gauteng</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-300">
                <SafeIcon icon={FiClock} className="h-4 w-4" />
                <span>08:00 - 16:00 Daily</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick links</h3>
            <nav className="space-y-2 text-sm">
              <a href="https://www.primehost.co.za/#/" className="block text-gray-300 hover:text-[#FF5841] transition-colors duration-200">Home</a>
              <a href="https://www.primehost.co.za/#/about" className="block text-gray-300 hover:text-[#FF5841] transition-colors duration-200">About us</a>
              <a href="https://www.primehost.co.za/#/services" className="block text-gray-300 hover:text-[#FF5841] transition-colors duration-200">Services</a>
              <a href="https://www.primehost.co.za/#/pricing" className="block text-gray-300 hover:text-[#FF5841] transition-colors duration-200">Pricing</a>
              <a href="https://www.primehost.co.za/#/portfolio" className="block text-gray-300 hover:text-[#FF5841] transition-colors duration-200">Portfolio</a>
              <a href="https://www.primehost.co.za/#/contact" className="block text-gray-300 hover:text-[#FF5841] transition-colors duration-200">Contact</a>
            </nav>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <nav className="space-y-2 text-sm">
              <a href="https://www.primehost.co.za/#/services#hosting" className="block text-gray-300 hover:text-[#FF5841] transition-colors duration-200">Web hosting</a>
              <a href="https://www.primehost.co.za/#/services#email" className="block text-gray-300 hover:text-[#FF5841] transition-colors duration-200">Email hosting</a>
              <a href="https://www.primehost.co.za/#/services#design" className="block text-gray-300 hover:text-[#FF5841] transition-colors duration-200">Web design</a>
              <a href="https://www.primehost.co.za/#/services#domains" className="block text-gray-300 hover:text-[#FF5841] transition-colors duration-200">Domain registration</a>
              <a href="https://www.primehost.co.za/#/faq" className="block text-gray-300 hover:text-[#FF5841] transition-colors duration-200">FAQ</a>
              <a href="https://www.primehost.co.za/#/knowledge" className="block text-gray-300 hover:text-[#FF5841] transition-colors duration-200">Knowledge base</a>
            </nav>
          </div>

          {/* Contact Us */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact us</h3>
            <div className="space-y-3 text-sm">
              <a href="tel:+27100070690" className="flex items-center space-x-2 text-gray-300 hover:text-[#FF5841] transition-colors duration-200">
                <SafeIcon icon={FiPhone} className="h-4 w-4" />
                <span>+27 10 007 0690</span>
              </a>
              <a href="mailto:support@primehost.co.za" className="flex items-center space-x-2 text-gray-300 hover:text-[#FF5841] transition-colors duration-200">
                <SafeIcon icon={FiMail} className="h-4 w-4" />
                <span>support@primehost.co.za</span>
              </a>
              <a 
                href="https://www.primehost.co.za/#/portal" 
                className="inline-block bg-teal-700 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-teal-800 transition-colors duration-200 mt-2"
              >
                Client portal
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 Primehost. All rights reserved.
          </p>
          <nav className="flex space-x-6 mt-4 md:mt-0">
            <a href="https://www.primehost.co.za/#/privacy" className="text-gray-400 hover:text-[#FF5841] text-sm transition-colors duration-200">
              Privacy policy
            </a>
            <a href="https://www.primehost.co.za/#/terms" className="text-gray-400 hover:text-[#FF5841] text-sm transition-colors duration-200">
              Terms of service
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}

export default Footer;